import React from 'react';
import { Box as MuiBox } from '@material-ui/core';

export const Box = (props) => {
    return (<MuiBox {...props} />);
}